import React, { FC, PropsWithChildren, useEffect } from 'react';
import { usePatientContext } from '../../contexts/patient-context';
import { usePaymentConfig } from '../hooks/payment-config-hook';
import { usePaymentSubmissionsContext } from '../../contexts/payment-submissions-context';
import AddExpenseFormComponent from './add-expense-form';

const PaymentSubmissionPageComponent: FC<PropsWithChildren> = () => {
  const { patient } = usePatientContext();

  const {
    data: { expenseCategories },
    fetchExpenseCategories,
  } = usePaymentConfig();

  const { selectedPaymentCategory, selectedPaymentSubcategory } =
    usePaymentSubmissionsContext();

  useEffect(() => {
    if (
      patient?.protocolId &&
      selectedPaymentCategory?.id &&
      selectedPaymentSubcategory?.id
    ) {
      fetchExpenseCategories(
        patient?.protocolId as string,
        selectedPaymentCategory?.id as string,
        selectedPaymentSubcategory?.id as string
      );
    }
  }, [patient]);

  return <AddExpenseFormComponent expenseCategories={expenseCategories} />;
};

export default PaymentSubmissionPageComponent;
